var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.2 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Nuovo_campione_sfumatura_1);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nuovo_campione_sfumatura_1",
    x1: 30.38,
    y1: -17.74,
    x2: 156.5,
    y2: 198.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63312"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H123.61A25.44,25.44,0,0,1,146,13.42c.63,1.18,1.13,2.09,1.38,2.52,26.8,45.45,48.51,80.87,75.3,126.32,2.75,4.66,3.52,10.35.84,15.05-2.53,4.43-9.92,7.69-13.83,7.69H41L0,99.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-3",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2-2",
    "data-name": "Livello 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52,146.4V78.13c0-2.18,2.13-3.94,4.77-3.94h98.29c2.63,0,4.77,1.76,4.77,3.94V88.79h-21c-2.64,0-4.77,1.76-4.77,3.94V126.3L114.8,131V92.71c0-2.18-2.13-3.94-4.77-3.94H71.25v9c0,2.18,2.14,4,4.77,4H96.34c2.64,0,4.77,1.77,4.77,3.94v7c0,2.18-2.13,4-4.77,4H76c-2.63,0-4.77,1.76-4.77,3.94v21.2Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoheader);
export default __webpack_public_path__ + "static/media/Logoheader.c80a12e836ca5320bd016520057ec21e.svg";
export { ForwardRef as ReactComponent };